import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import styles from "./styles";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/storage");
require("firebase/firestore");
const storage = firebase.storage();

class Configuracion extends React.Component {
  constructor() {
    super();
    this.state = {
      data: null,
      telefono: "",
      direccion: "",
      email: "",
      web: "",
      ciudad: "",
      edit: false,
      image: null,
      url: "",
      guardado: false,
    };
  }
  componentDidMount = async () => {
    let data = null;
    await firebase
      .firestore()
      .collection("datosConfiguracion")
      .doc("datos")
      .get()
      .then(async function (doc) {
        if (doc.exists) {
          data = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
    await this.setState({
      telefono: data.telefono,
      direccion: data.direccion,
      ciudad: data.ciudad,
      email: data.email,
      web: data.web,
      url: data.img,
    });
  };
  guardar = () => {
    firebase.firestore().collection("datosConfiguracion").doc("datos").set({
      telefono: this.state.telefono,
      direccion: this.state.direccion,
      ciudad: this.state.ciudad,
      email: this.state.email,
      web: this.state.web,
      img: this.state.url,
    });
    this.handleClick();
  };
  handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({ image }));
    }
  };
  handleUpload = () => {
    const { image } = this.state;
    const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progrss function ....
      },
      (error) => {
        // error function ....
        console.log(error);
      },
      () => {
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            this.setState({ url });
            this.saveUrl(url);
          });
      }
    );
  };
  saveUrl = async (url) => {
    await firebase
      .firestore()
      .collection("datosConfiguracion")
      .doc("datos")
      .set({
        telefono: this.state.telefono,
        direccion: this.state.direccion,
        ciudad: this.state.ciudad,
        email: this.state.email,
        web: this.state.web,
        img: url,
      });
    this.handleClick();
  };
  handleClose = () => {
    this.props.handleClose();
  };
  handleClick = () => {
    this.props.handleClick();
  };
  render() {
    const { classes } = this.props;
    const { data } = this.state;

    return (
      <div>
        <div className={classes.content}>
          <div style={{ display: "flex" }}>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ marginTop: "auto", marginBottom: "auto", color: "gray" }}
            >
              Logo:
            </Typography>
            <img
              className={classes.logo}
              src={this.state.url || "http://via.placeholder.com/400x300"}
              alt="Boclaims"
            />
            <br />
            <input
              type="file"
              style={{ display: "none" }}
              id="logo"
              key="logo"
              onChange={this.handleChange}
            />
            <label htmlFor="logo">
              <Button
                variant="contained"
                component="span"
                color="primary"
                style={{ margin: "20px", textTransform: "none" }}
              >
                Cargar Imagen
              </Button>
            </label>
            {this.state.image ? (
              <div>
                <Button
                  variant="contained"
                  component="span"
                  color="primary"
                  style={{ margin: "20px", textTransform: "none" }}
                  onClick={this.handleUpload}
                >
                  Guardar
                </Button>
              </div>
            ) : null}
            <br />
          </div>
          <div style={{ display: "flex" }}>
            <TextField
              style={{ width: "70%" }}
              label="Direccion"
              value={this.state.direccion}
              onChange={(e) =>
                this.setState({
                  direccion: e.target.value,
                  edit: true,
                })
              }
              margin="normal"
              variant="outlined"
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextField
              style={{ width: "70%" }}
              label="Ciudad"
              value={this.state.ciudad}
              onChange={(e) =>
                this.setState({
                  ciudad: e.target.value,
                  edit: true,
                })
              }
              margin="normal"
              variant="outlined"
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextField
              style={{ width: "30%" }}
              label="Email"
              value={this.state.email}
              onChange={(e) =>
                this.setState({
                  email: e.target.value,
                  edit: true,
                })
              }
              margin="normal"
              variant="outlined"
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextField
              style={{ width: "30%" }}
              label="Web"
              value={this.state.web}
              onChange={(e) =>
                this.setState({
                  web: e.target.value,
                  edit: true,
                })
              }
              margin="normal"
              variant="outlined"
            />
          </div>
          <div style={{ display: "flex", width: "70%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <TextField
                style={{ width: "250px" }}
                label="Telefono"
                value={this.state.telefono}
                onChange={(e) =>
                  this.setState({ telefono: e.target.value, edit: true })
                }
                margin="normal"
                variant="outlined"
              />
            </div>
            {this.state.edit ? (
              <div
                style={{
                  display: "flex",
                  // width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <br />
                <div
                  style={{
                    marginTop: "15px",
                  }}
                >
                  <Button
                    onClick={this.guardar}
                    variant="contained"
                    color="primary"
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <br />
        <br />
        <br />
        <br />
        <br />
        <div className={classes.footer}>
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{ margin: "auto" }}
              variant="caption"
              display="block"
              gutterBottom
            >
              Sistema desarrollado por Solunatec​
            </Typography>
            <Link href="http://www.solunatec.com/es/" target="_blank">
              <Typography
                style={{ margin: "auto" }}
                variant="caption"
                display="block"
                gutterBottom
              >
                www.solunatec.com
              </Typography>
            </Link>
            <Typography
              style={{ margin: "auto" }}
              variant="caption"
              display="block"
              gutterBottom
            >
              (662) 2108799
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Configuracion);
